import {css, cx} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {Message} from "@pg-design/message-module";
import {IOption, Select} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";

import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {ROOMS_FILTER_OPTIONS} from "../constants/rooms_filter_options";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {trackPricesCityRoomsFilterApplied} from "../tracking/track_prices_city_rooms_filter_applied";
import {PricesCitySectionName} from "../tracking/track_prices_city_view_section";
import {usePricesContext} from "./PricesContextFilterProvider";

interface Props {
    instanceId: string;
    sectionName: PricesCitySectionName;
    location: PricesCityAnalyticsLocation;
    /** Districts table keeps its own rooms filter, independent from the shared one - it always shows
     * average data, so it stays selectable even when priceStat === "median" disables the shared control. */
    independent?: boolean;
    className?: string;
}

export const RoomsFilterSelect = (props: Props) => {
    const {instanceId, sectionName, location, independent, className} = props;

    const {rooms, setRooms, districtRooms, setDistrictRooms, priceStat, setPriceStat} = usePricesContext();
    const activeRooms = independent ? districtRooms : rooms;
    const setActiveRooms = independent ? setDistrictRooms : setRooms;
    const selectedRoomsOption = ROOMS_FILTER_OPTIONS.find((option) => option.value === activeRooms) ?? ROOMS_FILTER_OPTIONS[0];
    const isDisabled = !independent && priceStat === "median";

    const handleRoomsChange = (option: IOption<RoomsFilter>) => {
        setActiveRooms(option.value);
        scheduleTrackingTask(() => trackPricesCityRoomsFilterApplied({rooms: option.label, sectionName, location}));
    };

    const select = (
        <Select
            instanceId={instanceId}
            options={ROOMS_FILTER_OPTIONS}
            value={selectedRoomsOption}
            onChange={(option) => handleRoomsChange(option as IOption<RoomsFilter>)}
            isDisabled={isDisabled}
        />
    );

    return (
        <div className={cx(wrapperStyle, className)}>
            <Text variant="body_copy_2" color="var(--colors-secondary)" mb={0.5} style={{verticalAlign: "middle"}}>
                Liczba pokoi
            </Text>

            {isDisabled ? (
                <DsTooltip
                    popover={
                        <Message type="info">
                            <Message.Content>
                                Aby wybrać liczbę pokoi,{" "}
                                <button type="button" className={switchLinkStyle} onClick={() => setPriceStat("average")}>
                                    przełącz na Średnią
                                </button>
                                .
                            </Message.Content>
                        </Message>
                    }
                    type="info"
                    placement="top"
                    interactive
                >
                    {({refs, getReferenceProps}) => (
                        <div ref={refs.setReference} {...getReferenceProps()}>
                            {select}
                        </div>
                    )}
                </DsTooltip>
            ) : (
                select
            )}
        </div>
    );
};

const wrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    minWidth: "16rem",
    width: "100%",

    md: {
        maxWidth: "22.4rem"
    }
});

const switchLinkStyle = css({
    display: "inline",
    padding: 0,
    border: "none",
    background: "none",
    font: "inherit",
    color: "inherit",
    textDecoration: "underline",
    cursor: "pointer"
});
import {css, cx} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {Message} from "@pg-design/message-module";
import {IOption, Select} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";

import {scheduleTrackingTask} from "../../../tracking/utils/schedule_tracking_task";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {ROOMS_FILTER_OPTIONS} from "../constants/rooms_filter_options";
import {PricesCityAnalyticsLocation} from "../tracking/prices_city_analytics";
import {trackPricesCityRoomsFilterApplied} from "../tracking/track_prices_city_rooms_filter_applied";
import {PricesCitySectionName} from "../tracking/track_prices_city_view_section";
import {usePricesContext} from "./PricesContextFilterProvider";

interface Props {
    instanceId: string;
    sectionName: PricesCitySectionName;
    location: PricesCityAnalyticsLocation;
    /** Districts table keeps its own rooms filter, independent from the shared one - it always shows
     * average data, so it stays selectable even when priceStat === "median" disables the shared control. */
    independent?: boolean;
    className?: string;
}

export const RoomsFilterSelect = (props: Props) => {
    const {instanceId, sectionName, location, independent, className} = props;

    const {rooms, setRooms, districtRooms, setDistrictRooms, priceStat, setPriceStat} = usePricesContext();
    const activeRooms = independent ? districtRooms : rooms;
    const setActiveRooms = independent ? setDistrictRooms : setRooms;
    const selectedRoomsOption = ROOMS_FILTER_OPTIONS.find((option) => option.value === activeRooms) ?? ROOMS_FILTER_OPTIONS[0];
    const isDisabled = !independent && priceStat === "median";

    const handleRoomsChange = (option: IOption<RoomsFilter>) => {
        setActiveRooms(option.value);
        scheduleTrackingTask(() => trackPricesCityRoomsFilterApplied({rooms: option.label, sectionName, location}));
    };

    const select = (
        <Select
            instanceId={instanceId}
            options={ROOMS_FILTER_OPTIONS}
            value={selectedRoomsOption}
            onChange={(option) => handleRoomsChange(option as IOption<RoomsFilter>)}
            isDisabled={isDisabled}
        />
    );

    return (
        <div className={cx(wrapperStyle, className)}>
            <Text variant="body_copy_2" color="var(--colors-secondary)" mb={0.5} style={{verticalAlign: "middle"}}>
                Liczba pokoi
            </Text>

            {isDisabled ? (
                <DsTooltip
                    popover={
                        <Message type="info">
                            <Message.Content>
                                Aby wybrać liczbę pokoi,{" "}
                                <button type="button" className={switchLinkStyle} onClick={() => setPriceStat("average")}>
                                    przełącz na Średnią
                                </button>
                                .
                            </Message.Content>
                        </Message>
                    }
                    type="info"
                    placement="top"
                    interactive
                >
                    {({refs, getReferenceProps}) => (
                        <div ref={refs.setReference} {...getReferenceProps()}>
                            {select}
                        </div>
                    )}
                </DsTooltip>
            ) : (
                select
            )}
        </div>
    );
};

const wrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    minWidth: "16rem",
    width: "100%",

    md: {
        maxWidth: "22.4rem"
    }
});

const switchLinkStyle = css({
    display: "inline",
    padding: 0,
    border: "none",
    background: "none",
    font: "inherit",
    color: "inherit",
    textDecoration: "underline",
    cursor: "pointer"
});
